import Checkbox, { CHECKBOX_STATE } from 'Components/Atoms/Checkbox/Checkbox';
import HighlightedText from 'Components/Atoms/HighlightedText/HighlightedText';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { StoreState } from 'Store/Reducers';
import styles from './MultiSelectorField.module.sass';

const MultiSelectorFieldDropdownItem = ({item, iteration, searchQuery, activeValues, onClick, ...props}: any) => {
    const [state, setState] = useState({
        isOpen: searchQuery?.length > 0,
        iteration: iteration || 0
    });

    useEffect(() => {
        setState({...state, isOpen: searchQuery?.length > 0});
    }, [searchQuery]);

    const handleOpenClick = () => setState({...state, isOpen: !state.isOpen});
    const handleClick = () => onClick([item.id]);
    const handleChildClick = (v) => onClick(v);

    const getState = () => (activeValues.includes(item.id) || item.selected >= item.total)
        ? CHECKBOX_STATE.ACTIVE
        : (item.selected > 0 && item.selected < item.total) 
        ? CHECKBOX_STATE.SELECTED
        : CHECKBOX_STATE.INACTIVE;

    return <>
        <div className={`${styles['dropdown__item']} ${state.isOpen ? styles['dropdown__item--isOpen'] : ''} ${!item.children ? styles['dropdown__item--isChild'] : ''} ${item?.children ? styles['dropdown__item--'+getState()] : ''}`} onClick={handleOpenClick}>
            <div className={styles[`dropdown__item-${state.iteration}`]} />
            
            <div style={{width: !item.children ? '100%' : 'auto'}}>
                <Checkbox
                    label={<HighlightedText highlight={searchQuery || ''}>{props.labels && props.labels[item.id]}</HighlightedText>}
                    onClick={handleClick}
                    state={getState()}
                />
            </div>

            {
                item.total &&
                <div className={styles['dropdown__item-count']}>({item.selected > 0 ? item.selected + '/' : ''}{item.total})</div>
            }

            {
                item.children &&
                <div className={styles[`dropdown__item-arrow`]}>
                    <Icon
                        type={ICONS.CHEVRON_DOWN}
                        size={'small'}
                    />
                </div>
            }
        </div>
        {
            item.children && state.isOpen && item.children.map((child) => <MultiSelectorFieldDropdownItem
                key={child.id}
                item={child}
                labels={props.labels}
                iteration={state.iteration+1}
                activeValues={activeValues}
                searchQuery={searchQuery}
                onClick={handleChildClick}
            />)
        }
    </>;
}

export default connect((state: StoreState) => ({
}), {

})(MultiSelectorFieldDropdownItem);